import { defineComponent } from "vue";

import routes from "./ReportsRouter";

import LevelTwo from "../LevelTwo/LevelTwo.vue";

export default defineComponent({
    components: {
        LevelTwo
    },

    data() {
        return {
            router: null
        };
    },

    async mounted() {
        this.router = routes.filter((route) => route.meta?.showInLevelTwoNav !== false);
    }
});
